import { render, staticRenderFns } from "./team-manage.vue?vue&type=template&id=3817a703&scoped=true"
import script from "./team-manage.vue?vue&type=script&lang=js"
export * from "./team-manage.vue?vue&type=script&lang=js"
import style0 from "./team-manage.vue?vue&type=style&index=0&id=3817a703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817a703",
  null
  
)

export default component.exports